import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Subscription } from "shared/interfaces/Subscription";
import {
  fetchUserSubscription,
  fetchQuincySubscriptionUsage,
  fetchSubscriptionPrices,
} from "shared/service/StrmService";

export const getUserSubscription = createAsyncThunk(
  "subscription/GetUserSubscription",
  async () => {
    const response: any = await fetchUserSubscription();
    return response;
  }
);

export const getQuincySubscriptionUsage = createAsyncThunk(
  "subscription/GetQuincySubscriptionUsage",
  async () => {
    const response: any = await fetchQuincySubscriptionUsage();
    return response;
  }
);

export const getSubscriptionPrices = createAsyncThunk(
  "subscription/GetSubscriptionPrices",
  async () => {
    const response: any = await fetchSubscriptionPrices();
    return response;
  }
);

export type SubscriptionState = {
  subscription: {
    subscriptionInfo: Subscription;
    loadingSubscription: boolean;
    quincyUsage: number;
    loadingQuincyUsage: boolean;
    subscriptionPrices: {
      currency: string;
      monthlyAmount: number;
      yearlyAmount: number;
    };
    loadingSubscriptionPrices: boolean;
  };
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    subscriptionInfo: {} as Subscription,
    loadingSubscription: false,
    quincyUsage: 0,
    loadingQuincyUsage: false,
    subscriptionPrices: {},
    loadingSubscriptionPrices: false,
  },
  reducers: {},
  extraReducers: {
    [getUserSubscription.pending.type]: (state) => {
      state.loadingSubscription = true;
    },
    [getUserSubscription.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.subscriptionInfo = action.payload;
      }
      state.loadingSubscription = false;
    },
    [getUserSubscription.rejected.type]: (state) => {
      state.loadingSubscription = false;
    },
    [getQuincySubscriptionUsage.pending.type]: (state) => {
      state.loadingQuincyUsage = true;
    },
    [getQuincySubscriptionUsage.fulfilled.type]: (state, action) => {
      state.quincyUsage = action.payload;
      state.loadingQuincyUsage = false;
    },
    [getQuincySubscriptionUsage.rejected.type]: (state) => {
      state.loadingQuincyUsage = false;
    },
    [getSubscriptionPrices.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.subscriptionPrices = action.payload;
      }
      state.loadingSubscriptionPrices = false;
    },
    [getSubscriptionPrices.pending.type]: (state) => {
      state.loadingSubscriptionPrices = true;
    },
    [getSubscriptionPrices.rejected.type]: (state) => {
      state.loadingSubscriptionPrices = false;
    },
  },
});

export default subscriptionSlice.reducer;
